import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/plan.py PlanOut.
export interface Plan {
  plan_id: number;
  name: string;
  description: string | null;
  is_default: boolean;
  billing_cycle: string;
  did_monthly_rate: number;
  weekly_fee: number;
}

// Mirrors RateOut.
export interface Rate {
  rate_id: number;
  plan_id: number;
  destination_id: number;
  service_flag: number;
  rate: number;
  billing_increment: number;
  billing_type: string;
  weight: number;
}

export async function listPlans(): Promise<Plan[]> {
  const resp = await api.get<APIResponse<Plan[]>>("/plans/");
  return unwrap(resp.data);
}

export async function listPlanRates(planId: number): Promise<Rate[]> {
  const resp = await api.get<APIResponse<Rate[]>>(`/plans/${planId}/rates`);
  return unwrap(resp.data);
}

// NPA-NXX rate sheet (for the 'npa_nxx' billing mode).
export interface NpaNxxRateSummary {
  rows: number;
  updated_at: string | null;
  default_interstate: number | null;
  default_intrastate: number | null;
}

export async function getNpaNxxRateSummary(): Promise<NpaNxxRateSummary> {
  const resp = await api.get<APIResponse<NpaNxxRateSummary>>("/plans/npa-nxx-rates/summary");
  return unwrap(resp.data);
}

export async function uploadNpaNxxRates(file: File): Promise<{ loaded: number; skipped: number }> {
  const fd = new FormData();
  fd.append("file", file);
  const resp = await api.post<APIResponse<{ loaded: number; skipped: number }>>(
    "/plans/npa-nxx-rates/upload",
    fd,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return unwrap(resp.data);
}
